function cssVariablesObjectToString(variables) {
  return Object.entries(variables).map((_ref) => {
    let [name, value] = _ref;
    return `${name}: ${value};`;
  }).join("");
}

export { cssVariablesObjectToString };